import {useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import {getDomainConfig} from '~/domains'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'

const ReasoningSection = () => {
  const {language, deviceType, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)

  const device = deviceType === 'smartphone' ? 'mobile' : 'desktop'

  return (
    <div className="!max-w-screen !min-w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] min-h-min !w-screen bg-gradient-to-r from-pink-100 to-fuchsia-100 py-8">
      <div
        className={clsx(
          'mx-auto flex flex-col justify-center',
          `${stylesBydomain.UTILS_MAIN_CONTAINER} utils_main_container`,
        )}
      >
        <span className="flex justify-center self-center text-center align-middle text-2xl font-semibold tracking-wide mobile:text-lg">
          {translations.ReasoningSection.title}
        </span>
        <div className="mt-6 flex flex-row justify-center gap-9 text-start tablet:flex-col tablet:text-center">
          <p className="text-base font-normal leading-6 tracking-normal desktop:mt-5 desktop:px-2 tablet:mt-0 tablet:px-14 mobile:px-3">
            {translations.ReasoningSection.infoText}
          </p>
          <div className="mx-auto flex h-auto max-w-[480px] shrink-0 grow-0 items-center justify-center">
            <img
              src={`https://dt47coepsakuj.cloudfront.net/images/${device}/how-do-we-rank.png`}
              alt="headphones-stars"
              loading="lazy"
              className="h-full w-full object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReasoningSection
